import React from "react";
import { NavLink } from "react-router-dom";
import { conference0 } from "../../assets/imgExport";

export default function StepAlpineConferencePreview({
  withTitle = false,
}: {
  withTitle?: boolean;
}) {
  const lang = false;
  return (
    <div className="py-24">
      {withTitle && (
        <h2 className="font-header text-3xl mb-10 leading-normal">
          {lang ? "Latest News" : "最新动态"}
        </h2>
      )}
      <div className="flex flex-col sm:flex-row bg-gray-200">
        <img
          className="w-full h-[300px] sm:h-auto sm:w-1/2 object-cover"
          src={conference0}
          alt={
            lang
              ? "STEP Alpine Conference 2026 in Interlaken, Switzerland"
              : "2026年瑞士因特拉肯STEP阿尔卑斯会议"
          }
        />
        <div className="p-10 sm:w-1/2">
          <p className="font-medium pb-4">
            {lang ? "NEWS · MAY 2026" : "新闻报道 · 2026年5月"}
          </p>
          <p className="font-header text-3xl flex flex-col">
            {lang ? (
              <>
                <span>New Vision at</span>
                <span>STEP Alpine 2026</span>
              </>
            ) : (
              <>
                <span>受邀出席2026年</span>
                <span>瑞士STEP阿尔卑斯会议</span>
              </>
            )}
          </p>
          <p className="py-4 text-sm mb-4">
            {lang
              ? "The New Vision Family Office team joined leading professionals from nearly 50 countries at the STEP Alpine Conference 2026 in Interlaken — a defining gathering for the global trust, family office and wealth succession community."
              : "新愿景家族办公室团队与来自近50个国家的业界精英齐聚瑞士因特拉肯，参加2026年STEP阿尔卑斯会议——全球信托、家族办公室与财富传承领域的重要盛会。"}
          </p>
          <NavLink
            to="/news/step-alpine-conference-2026"
            className="bg-black text-white px-3 py-1 font-medium text-sm"
          >
            {lang ? "READ MORE" : "阅读更多"}
          </NavLink>
        </div>
      </div>
    </div>
  );
}
